import { render } from "./268VTip.vue?vue&type=template&id=09bdbe66&scoped=true"
import script from "./268VTip.vue?vue&type=script&lang=js"
export * from "./268VTip.vue?vue&type=script&lang=js"

import "./268VTip.vue?vue&type=style&index=0&id=09bdbe66&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bdbe66"]])

export default __exports__